import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://ddujoaiecczeqeizcexh.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkdWpvYWllY2N6ZXFlaXpjZXhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTcwMzU0ODQsImV4cCI6MTk3MjYxMTQ4NH0.d_L9HZMck4r3H2ltl-gKvF-J7wjje5heVd0xkcuqIPg"

export const supabase = createClient(supabaseUrl, supabaseAnonKey)